<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Name
        b-col(md="6")
          b-form-group(
            :label="$t('label.Name')",
            label-for="question-type-name",
            description=""
          )
            validation-provider(:name="$t('label.Name')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="question-type-name",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

      // Button
      b-row
        b-col(
          cols="12"
          class="text-right"
        )
          b-button(
            variant="primary",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}

</template>

<script>
import { ref, toRefs } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: ['data', 'isSubmitting'],

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)

    const validateForm = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validateForm()
        .then(() => emit('submit', toRefs(props.data)))
        .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    return {
      form,
      validateAndSubmit,
    }
  },
}
</script>

<style scoped>

</style>
